module.exports = __webpack_public_path__ + "img/BETFAIR.ES.2eeb7fbe.svg";